import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-analytics-pagination-controller',
  templateUrl: './analytics-pagination-controller.component.html',
  styleUrl: './analytics-pagination-controller.component.scss'
})
export class AnalyticsPaginationControllerComponent {
  @Input() totalPages = 0;
  @Input() currentPage = 1;

  @Output() pageChange = new EventEmitter<number>();

  goToNextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.pageChange.emit(this.currentPage + 1);
    }
  }

  goToPrevPage(): void {
    if (this.currentPage > 1) {
      this.pageChange.emit(this.currentPage - 1);
    }
  }
}
